import Aside from "../Component/Aside";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Table from "../Component/Table";

export default function TableExample() {
    return <>
        <Header />
        <Aside />
        <Table />
        <Footer />
    </>
}